import { useMemo } from 'react';

import { useCurrentUserStore } from 'store/currentUser';

import { EUnavailableType } from 'components/Pages/UnavailableContent/constants/unavailableType';
import { useUnavailableContent } from 'components/Pages/UnavailableContent/hooks/useUnavailableContent';

import type { ErrorResponse } from 'providers/declare';

import { useRedirectToAuth } from 'hooks/useRedirectToAuth';

/** Хук для работы с редиректом недоступного видео */
export function useUnavailableVideo() {
    const { redirectToUnavailableContentPage } = useUnavailableContent();
    const redirectToAuth = useRedirectToAuth();
    const { currentUser } = useCurrentUserStore();

    return useMemo(
        () => ({
            manageNoRecordLink: () => {
                redirectToUnavailableContentPage(EUnavailableType.RECORD_NOT_FOUND);
            },
            /** Функция вернет `true` если будет редирект */
            manageUnavailableVideo: (videoResponse: Response | ErrorResponse) => {
                const status = (() => {
                    if ('statusCode' in videoResponse) {
                        return videoResponse.statusCode;
                    }

                    return videoResponse.status;
                })();

                if (status === 404) {
                    redirectToUnavailableContentPage(EUnavailableType.RECORD_NOT_FOUND);

                    return true;
                }

                if (status === 403) {
                    if (currentUser?.type === 'manager') {
                        redirectToAuth();
                    } else {
                        redirectToUnavailableContentPage(EUnavailableType.RESTRICTED_AREA);
                    }

                    return true;
                }

                if (status !== 200) {
                    redirectToUnavailableContentPage(EUnavailableType.RECORD_UNAVAILABLE);

                    return true;
                }

                return false;
            },
        }),
        [redirectToUnavailableContentPage, redirectToAuth, currentUser?.type],
    );
}
